/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-restricted-globals                        */
/* ***************************************************************** */
/**
 * Returns the default growing year for the application.
 */
export function getDefaultGrowingYear() {
  const currentDate = new Date();

  // Return the current year, or next year if month >= Sept.
  return currentDate.getMonth() >= 8
    ? currentDate.getFullYear() + 1
    : currentDate.getFullYear();
}

const removeOffset = (date) => {
  const ms = new Date(date).getTime();
  const offset = new Date(ms).getTimezoneOffset() * 60;

  date = new Date(ms + offset * 1000);
  return date;
};

/**
 * Gets a formatted date string from a given date input string.
 * @param {String} date - The date input string.
 * @param {String} format - The desired date format.
 * @param {Boolean} preserveTimeZone - Specifies if the time zone should be preserved.
 */
export function getFormattedDate(
  date,
  format = 'mdy',
  preserveTimeZone = false,
) {
  if (!date) return null;

  let dateString = removeOffset(date);
  if (!preserveTimeZone) {
    dateString = date.replace('Z', '');
  }

  const d = new Date(dateString);
  if (isNaN(d)) return null;

  switch (format.toLowerCase()) {
    case 'mdy':
    default:
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  }
}

/**
 * Parses a date from a date string.
 * @param {String} date - The date input string.
 * @param {Date} defaultDate - The default date to return if the value can't be parsed.
 * @returns {Date} - The parsed date.
 */
export function getParsedDate(date, defaultDate) {
  if (!date) return defaultDate;

  const d = new Date(date);
  if (isNaN(d)) return defaultDate;

  return d;
}
